import React, { useEffect, useState } from "react";
import { BaseState, StateKeys } from "../../redux/states/main.state";
import {
  ClassResponse,
  ContentResponse,
  CourseResponse,
  TestResponse,
} from "../../services/api.response.service";
import { Col, Nav, Row, Spinner, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import Languages from "../Languages";
import {
  AppState,
  CheckContentProviderIdExist,
  getContentProviderId,
  getLanguageByDefault,
} from "../../services/app.service";
import { RouteEndpoints } from "../../services/route.service";
import NoData from "../../pages/main/NoData";

import { Mixpanel } from "../../services/mixpanel";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import Card from "../Card";
import SubscribeAccessButton from "./SubscribeAccessButton";
import TestsCardList from "../TestsCardList";
import CoursesSection from "./CoursesSection";
import TestsSection from "./TestsSection";

interface props {
  classDetails: ClassResponse;
  // contents: ContentResponse[],
  tests: TestResponse[];
  // handleSetCourse: (id: string, title: string) => void;
  tab: any;
}

const ClassTabsView = ({
  classDetails,
  tab,
  // contents,
  tests,
  // handleSetCourse,
}: props) => {
  const getLanguage = getLanguageByDefault();

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const handleSetCourse = (id: string, title: string) => {
    if (!classDetails.has_paid) {
      return alert(getLanguage.subscribeToView);
    }
    window.location.href = currentUser.ecampus_id
      ? RouteEndpoints.COURSE_CONTENT(id)
      : RouteEndpoints.SIGN_IN;
  };

  console.log("ClassTabs Test:", tests);

  return (
    <>
      <div className="">
        <Col md={12} className="overflow-hidden">
          {/*<Col md={12} className="content-card p-4 overflow-hidden">*/}
          <Tab.Container defaultActiveKey={tab.length ? tab : "courses"}>
            <div className="user-tabing">
              <Nav
                as="ul"
                variant="pills"
                className="d-flex align-items-center justify-content-start course-tab p-0 m-0"
              >
                <Nav.Item as="li" className=" col-12 col-sm-2 p-0  ">
                  <Nav.Link
                    eventKey="courses"
                    role="button"
                    className="text-center p-0 m-0"
                  >
                    {getLanguage.sections}{" "}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li" className="col-12 col-sm-2 p-0">
                  <Nav.Link
                    eventKey="tests"
                    role="button"
                    className="text-center p-0 m-0"
                  >
                    {getLanguage.test}{" "}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <hr
                style={{
                  margin: "0",
                  // borderTop: "1px solid #e9ecef",
                }}
              />
            </div>

            <Col sm={12} className="tab-content-container scrollbar-dd">
              <Tab.Content>
                <Tab.Pane eventKey="courses">
                  <Row>
                    {
                      // contents.length > 0 ? (
                      //   contents.length > 0 ? (
                      <CoursesSection
                        classDetails={classDetails}
                        // contents={contents}
                        handleSetCourse={handleSetCourse}
                      />
                      //     ) : (
                      //
                      //         <Loader noCard imageLoader />
                      //         // <NoData title="noCourses" />
                      //     )
                      // ) : (
                      //
                      //     <Loader noCard imageLoader />
                      //     // <NoData title="noCourses" />
                      // )
                      //
                    }

                    {/*<Col md={12}>*/}
                    {/*  {details.pageState ===*/}
                    {/*    AppState.LOADING_MORE && (*/}
                    {/*    <Loader noCard imageLoader />*/}
                    {/*  )}*/}
                    {/*</Col>*/}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="tests">
                  <Row>
                    {
                      //   (tests.pageState === AppState.LOADED ||
                      // tests.pageState ===
                      //   AppState.LOADING_MORE)

                      tests.length > 0 && (
                        <>
                          {tests.length > 0 ? (
                            tests?.length > 0 ? (
                              <TestsSection
                                tests={tests}
                                handleSetTest={(id: string) => {
                                  Mixpanel.track("Tap Test", {
                                    with: "Auth",
                                    user_id: "",
                                    test_id: "",
                                    test_name: "",
                                    ...(classDetails?.content_provider_id
                                      ? {
                                          content_provider_id:
                                            classDetails?.content_provider_id,
                                        }
                                      : {}),
                                  });
                                  window.location.href =
                                    RouteEndpoints.CLASS_COURSES_TEST(id);
                                }}
                              />
                            ) : (
                              // <TestsCardList
                              //     tests={tests}
                              // />
                              <NoData title="noTest" />
                            )
                          ) : (
                            <NoData title="noTest" />
                          )}
                        </>
                      )
                    }
                    {/*<Col md={12}>*/}
                    {/*  {(tests.pageState === AppState.LOADING_MORE ||*/}
                    {/*    tests.pageState === AppState.LOADING) && (*/}
                    {/*    <Loader noCard imageLoader />*/}
                    {/*  )}*/}
                    {/*</Col>*/}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Tab.Container>
        </Col>
      </div>
    </>
  );
};

export default ClassTabsView;
